import posthog from "posthog-js";
import { Button, Divider, Flex, Popover, Typography } from "antd";
import { Link } from "react-router-dom";
import { useAuthContext } from "./AuthProvider";
import { PATHS } from "../../utills/paths";
import UXAvatar from "../layouts/UXAvatar";
import CustomIcon from "../layouts/CustomIcon";

const { Text } = Typography;

// Link Item
function LinkItem({ target = "_self", icon, name, link, disabled = false, isExternalLink = false, onClick = () => {} }) {
  return (
    <Link
      to={link}
      target={target}
      onClick={onClick}
      className={`account-dropdown__link d-flex h-bg-F7F7F8 transition ${disabled ? "disabled" : ""}`}
    >
      <Flex gap={8} align='center' className='w-100'>
        <CustomIcon name={icon} height={22} width={22} rootClassName='account-dropdown__link-icon' />
        <Text className='account-dropdown__link-text'>{name}</Text>
        {isExternalLink && <CustomIcon name='arrow_narrow_up_right' height={22} width={22} rootClassName='color-6C6C89' />}
      </Flex>
    </Link>
  );
}

export default function AccountDropdown() {
  const { user, userAccess, planInfo } = useAuthContext();
  const { isOrgAdminOrOwner = false } = userAccess || {};
  const { isCustomPlan = false, isPlanCancelled = false, plan = {} } = planInfo || {};
  const showUpgradePlan = !isCustomPlan && isOrgAdminOrOwner && !isPlanCancelled;

  return (
    <Popover
      arrow={false}
      trigger='click'
      placement='right'
      classNames={{ root: 'account-dropdown-popover' }}
     
      styles={{ root: { width: 270 }, container: {
        padding: 0,
        width: 270,
      } }}
      content={
        <div className='account-dropdown__content'>
          <Text className='account-dropdown__email'>{user?.email}</Text>

          <LinkItem key='profile' icon='user_edit' name='Edit Profile' link={PATHS.V2.EDIT_PROFILE} />
          <Divider className='account-dropdown__divider' />

          {showUpgradePlan && (
            <>
              <LinkItem key='upgrade' icon='upgrade' name='Upgrade Plan' link={PATHS.V2.PLANS} />
              <Divider className='account-dropdown__divider' />
            </>
          )}

          {user?.supportLink && (
            <>
              <LinkItem
                key='admin'
                icon='settings_01'
                name={user.isAdmin ? "Admin Panel" : "Admin Support Panel"}
                link={user.supportLink}
              />
              <Divider className='account-dropdown__divider' />
            </>
          )}

          {user?.hasTeam && (
            <>
              <LinkItem key='team' icon='users_01' name='Team Account' link={PATHS.TEAM} />
              <Divider className='account-dropdown__divider' />
            </>
          )}

          {user?.hasRecruit && (
            <>
              <LinkItem key='recruit' icon='user-plus' name='Recruit' link={PATHS.RECRUIT} />
              <Divider className='account-dropdown__divider' />
            </>
          )}

          <LinkItem
            key='logout'
            icon='logout'
            name='Log Out'
            link={PATHS.LOGOUT}
            onClick={() => {
              posthog.reset();
              // Remove the popover open state from local storage
              localStorage.removeItem("isPopOverOpen");
            }}
          />
        </div>
      }
    >
      <Button size='large' className='account-dropdown__trigger w-100 d-flex p-10-20 h-bg-F7F7F8 bt-1px-E3E8EF transition' type='text'>
        <UserAvatar user={user} planInfo={planInfo} plan={plan} />
        <CustomIcon name='chev_right' rootClassName='account-dropdown__trigger-chev' />
      </Button>
    </Popover>
  );
}

function UserAvatar({ user, planInfo, plan }) {
  return (
    <div className='account-dropdown__user'>
      <UXAvatar userId={user?.id} logo={user?.profile_pic_name} text={user?.first_name?.charAt()} size={40} fontSize='18px' />

      <div className='d-flex flex-column'>
        <Text className='account-dropdown__user-name'>
          {user?.first_name} {user?.last_name || ""}
        </Text>

        <Text className='account-dropdown__user-plan'>{planInfo?.isTrialPlan ? plan?.name : `${plan?.name || "Free"} plan`}</Text>
      </div>
    </div>
  );
}
